<template>
    <div class="template-wrapper">
		<h2 class="page-title">會員列表</h2>
		<el-divider></el-divider>
		<template>
			<el-button @click="addtogroup">加入到群組</el-button>
		</template>
		
		<template v-if="qyid==598 || qyid==605">
			<export-excel
			:data="tableDataExcel"
			:fields = "tableDataExcelFields"
			name="會員列表.xls"
			class="el-button el-button--default">
				匯出會員列表
			</export-excel>
		</template>
        <!--<el-button @click="dialogVisible_duo=true">{{$t('sendall')}}</el-button>-->
   <!--     <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs> -->
        <el-table
            :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            stripe
            style="width: 100%"
			@sort-change="sortChange"
			@selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55" />
			<el-table-column
			prop="addtime"
			:label="$t('date')"
			sortable="custom"
			width="180">
			<template slot-scope="scope">
			         <div>{{scope.row.addtime | formatDate}} </div>
			       </template>
			</el-table-column>
			<el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
			</el-table-column>
            <el-table-column v-for="item in sjkData"
				:prop="item.key"
				:label="item.title"
				sortable="custom"
				>
				  <template   slot-scope="scope">
				  <div v-if="item.type=='choose'">{{scope.row[item.key]=='0'? item.optionst[0]:item.optionst[1]}}</div>
				  <div v-if="item.type!='choose'">{{scope.row[item.key]}} </div>
				  
				</template>  
            </el-table-column>
			<el-table-column
			prop="ordercount"
			label="交易次數"
			sortable="custom"
			width="180">
			<template slot-scope="scope">
			         <div>{{scope.row.ordercount}} (<a href="#" @click="showOrder(scope.row)">詳情</a>)</div>
			       </template>
			</el-table-column>
           
 <!--
			  <el-table-column
			      prop="operation"
			      label="管理"
			      align="center"
			      width="180">
			     <template slot-scope="scope">
			     <div class="operationVid">
			       <span class="operationBef" @click="huifu(scope.row)" >回覆</span>
			     
			    
 
			    </div>
			     </template>
			    </el-table-column>-->

		 		  <el-table-column
			      prop="operation"
			      label="管理"
			      align="center"
			      width="180">
			     <template slot-scope="scope">
			     <div class="operationVid">
					<el-button @click="huifu(scope.row)">回覆</el-button>

			    
 
			    </div>
			     </template>
			    </el-table-column>
		 
        </el-table>
        <div class="pagination flex-center">
			<span class="el-pagination__total">共 {{tableData.length}} 項</span>
            <el-pagination background  @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-size="pageSize"   layout="prev,pager,next" :total="tableData.length"></el-pagination>
        </div>

       <!-- 回覆单个客户 -->
        <el-dialog title="回覆" :visible.sync="dialogVisible" width="556px" :before-close="handleClose">
            <div class="add-template">
                <el-form ref="form" :model="form">

         <!--           <el-form-item :label="$t('templateType')">
                        <el-select v-model="form.type" placeholder="">
                            <el-option :label="$t('textTemplate')" value="1"></el-option>
                            <el-option :label="$t('picturesAndText')" value="2"></el-option>
                            <el-option :label="$t('ComprehensiveTemplate')" value="3"></el-option>
                        </el-select>
                    </el-form-item>
 -->
                    <span>回覆:{{hfdata.name}}</span>
                    <!-- <span>whatsapp:{{hfdata.whatsapp}}</span> -->
                    <el-form-item label="回覆文字">
                        <el-input v-model="form.msg" type="textarea" :rows="2"></el-input>
                    </el-form-item>

        
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false"> {{$t('Cancel')}}</el-button>
                <el-button type="primary" @click="replyto">{{$t('Sure')}}</el-button>
            </span>
        </el-dialog>
		 <!-- 回覆单个客户结束 -->
		
		
		<!-- 回覆多个客户 -->
		       <el-dialog :title="$t('replyall')" :visible.sync="dialogVisible_duo" width="556px" :before-close="handleClose">
		           <div class="add-template">
		               <el-form ref="form" :model="form">
		
		        <!--           <el-form-item :label="$t('templateType')">
		                       <el-select v-model="form.type" placeholder="">
		                           <el-option :label="$t('textTemplate')" value="1"></el-option>
		                           <el-option :label="$t('picturesAndText')" value="2"></el-option>
		                           <el-option :label="$t('ComprehensiveTemplate')" value="3"></el-option>
		                       </el-select>
		                   </el-form-item>
		-->
		                   <span>replyto:all</span>
		                   <!-- <span>whatsapp:{{hfdata.whatsapp}}</span> -->
		                   <el-form-item :label="$t('replytxt')">
		                       <el-input v-model="form.msg" type="textarea" :rows="2"></el-input>
		                   </el-form-item>
							<el-form-item :label="$t('templateid')">
		                       <el-input v-model="form.templateid" type="textarea" :rows="2"></el-input>
		                   </el-form-item>
		
		       
		               </el-form>
		           </div>
		           <span slot="footer" class="dialog-footer">
		               <el-button @click="dialogVisible_duo = false"> {{$t('Cancel')}}</el-button>
		               <el-button type="primary" @click="replytoall">{{$t('Sure')}}</el-button>
		           </span>
		       </el-dialog>
				 <!-- 回覆多个客户结束 -->
				 
				 
				  
		 
		<!-- 修改客户资料 -->
		
		  <el-dialog :title="$t('edit')" :visible.sync="dialogVisible_key" width="556px" :before-close="handleClose">
		           <div class="add-template">
		               <el-form ref="form" :model="formkey">
		
		           
				 			<el-form-item :label="$t('memo')">
							 <span> 備註</span>
		                       <el-input v-model="formkey.memo"></el-input>
								 
		                   </el-form-item> 
						   
							<el-form-item :label="$t('level')">
							 <span> </span>
		                       <el-input v-model="formkey.level"></el-input>
								 
		                   </el-form-item>  
 
		             
		               </el-form>
		           </div>
		           <span slot="footer" class="dialog-footer">
		               <el-button @click="dialogVisible_key = false">{{$t('Cancel')}}</el-button>
		               <el-button type="primary" @click="surekey">{{$t('Sure')}}</el-button>
		           </span>
		       </el-dialog>
				
		<!-- 修改客户资料结束 -->	
		
		
		<el-dialog title="加入到群組" :visible.sync="addtoGroupVisible" width="556px" :before-close="handleClose">
            <div class="add-template">
                <el-form ref="groupform" :model="groupform">
					<el-form-item label="加入到群組">
						<template>
							<div class="flex flex-wrap" style="display: flex">
								<el-select v-model="groupform.title" placeholder="">
									<template v-for="(item,index) in groupData">
										<el-option  :label="item.title" :value="item.id">{{item.title}}</el-option>
									</template>
								</el-select>
							</div>
						</template>
					</el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addtoGroupVisible = false"> {{$t('Cancel')}}</el-button>
                <el-button type="primary" @click="addToGroupAction">{{$t('Sure')}}</el-button>
            </span>
        </el-dialog>


		<el-dialog title="交易記錄" :visible.sync="dialogVisible_order" width="556px" :before-close="handleClose">
            <div class="add-template">
                <el-form ref="form" :model="form">
					<el-table
						:data="
							tableData_order.slice((currentPage_order - 1) * pageSize_order, currentPage_order * pageSize_order)
						"
						stripe
						@sort-change="sortChange_order"
						style="width: 100%"
						>

						<el-table-column prop="addtime" label="時間" sortable="custom">
							<template slot-scope="scope">
								<div>{{scope.row.addtime | formatDate}} </div>
							</template>
						</el-table-column>
						<el-table-column prop="orderid" label="訂單ID" sortable="custom">
						</el-table-column>
						<el-table-column prop="total_price" label="總金額" sortable="custom">
						</el-table-column>
					</el-table>
					<div class="pagination flex-center">
						<span class="el-pagination__total">共 {{tableData_order.length}} 項</span>
						<el-pagination
							background
							@current-change="handleCurrentChange_order"
							:current-page="currentPage_order"
							:page-size="pageSize_order"
							layout="prev,pager,next"
							:total="tableData_order.length"
						></el-pagination>
					</div>





                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible_order = false"> {{$t('Cancel')}}</el-button>
                <el-button type="primary" @click="dialogVisible_order = false">{{$t('Sure')}}</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
		import { formatDate } from '../../assets/date.js'
import {tongyong,sjk,funk,api_tongyong_edit } from '@/api'
import {addTemplate, getUsersReport, getDaifafile, getDaifalistByGroup, getShopOrder} from '@/api'
export default {
    data() {
        return {
			hfdata:[],
			sjk:'messenger_kehulist',
			currentPage: 1,  // 当前页码
			currentPage_order: 1,  // 当前页码
			pageSize: 15,  // 每页显示的行数
			pageSize_order: 10,  // 每页显示的行数
            activeName: '0',
            dialogVisible: false,
            dialogVisible_key: false,
            dialogVisible_duo: false,
			dialogVisible_order: false,
            tab: [
                {label: this.$t('underApproval'), id: '0'},
                {label: this.$t('passed'), id: '1'}
            ],
			tableData:[],
			tableDataExcel:[],
			tableDataExcelFields:{
				'add time': 'addtime',
				'name': 'name',
				'mobile': 'whatsapp',
				'number of order': 'ordercount'
			},
			sjkData:[],
            tableData1: [
              
            ],
			tableData_order:[],
			status:0,
            form: {
                templateid: '',
                msg: '',
              
            },
			formUser: {
					qyid: '',
					start: "1-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear(),
					end: new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate() +"-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear()
				},
			sform: {
							  parmas:{}
			},
			formkey:{
				keyword:'kkk'
			},
			qyid: '',
			selection: [],
			selectionlist:[],
			addtoGroupVisible: false,
			groupData: [],
			groupform:{
				title:''
			},
        }
    },
	filters: {
	  formatDate: function (time) {
	          time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
	                   let date = new Date(time)
	                   return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
	    } 
	  },
	created(option) {
		console.log('sjk',this.sjk);
		if(this.sjk){
			this.getsjk()
			this.getUserList()
			//this.gettemplist()
		}
		var user = JSON.parse(window.localStorage.getItem('userinfo'))
		this.qyid= user.id

		this.getGroupList();

		
	},
    methods: {
		edititem(data){
			this.dialogVisible_key=true
			this.action='edit'
			this.formkey = data 
		},
		huifu(data){
			this.dialogVisible=true 
			this.hfdata = data 
		},
		showOrder(data){
			console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaa')
			console.log(data.whatsapp)

			var user = JSON.parse(window.localStorage.getItem("userinfo"));

			let fdata = {
				qyid: user.id,
				whatsapp: data.whatsapp,
				action: "viewpaymentbywhatsapp"
			};
			getShopOrder(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.tableData_order = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});





			this.dialogVisible_order=true 
			//this.hfdata = data 
		},
		beforeHandleCommand(e){
			console.log(e);
		},
		 // 页面切换方法
		  handleCurrentChange(val) {
		    this.currentPage = val;
		  },
		  handleCurrentChange_order(val) {
		    this.currentPage_order = val;
		  },
        handleClick(tab, event) {
            console.log(tab.index);
			this.status=tab.index
			this.currentPage=1
			 this.gettemplist()
        },
        handleClose() {
            this.dialogVisible = false 
            this.dialogVisible_key = false 
            this.dialogVisible_duo = false 
			this.dialogVisible_order = false
			this.addtoGroupVisible = false 
        },
        handlePictureCardPreview() {

        },
        handleRemove() {

        },
		handleSelectionChange(val) {
			//alert(val)
			console.log('valllllllllllllll')
			console.log(val);
			this.selection=val;
		},
		addtogroup() {
			console.log('selectionnnnnnnnnnnnnnnnnnnnnnn')
			console.log(this.selection)
			this.selectionlist = this.selection;
			this.addtoGroupVisible=true;


			
		},
        // 新增範本点击确定
        sure() {
			 var user = JSON.parse(window.localStorage.getItem('userinfo'))
			 console.log(user);
		 
			 this.form.qyid= user.id
			 this.form.status= 0
            addTemplate(this.form).then(res => {
                if(res.code==1){
                    this.$message({
                        type: 'success',
                        message: res.msg
                    })
                    this.dialogVisible = false
					  this.gettemplist()
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }    
            })
        },
		//删除某个
		delitem(id){
			this.$confirm('您确定删除吗？').then(_ => {
			
			    console.log('del..');
				let  fdata= {
						sjk: this.sjk,
						action:'del',
						id:id
					}
				tongyong(fdata).then(res => {
					if(res.code==1){
					  console.log(res);
					  this.gettemplist()
					}else{
						this.$message({
							type: 'error',
							message: res.msg
						})
					}    
				})
			}).catch(_ => {
			
			　 
			
			})
			
			
		},
		userReport() {
			/*
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			let fdata = {
				qyid: user.id,
			};
			console.log('getUsersReport................')
			getUsersReportExcel(fdata).then(res => {
				if(res.code==1){
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					//this.tableData=res.data
					console.log('getUsersReporttttttttttttttttttttt')
				}else{
					console.log('eeeeeeeeeeeeeeeeeeeeee')
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})*/
			
		},
		getGroupList() {
			var user = JSON.parse(window.localStorage.getItem("userinfo"));
			let fdata = {
				qyid: user.id,
			};
			getDaifafile(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.groupData = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			})
		},
		addToGroupAction() {
			console.log('addToGroupActionnnnnnnnnnnnnnnnn')
			console.log('groupform.title: ' + this.groupform.title)
			console.log('this.selection: ' + this.selection)
			console.log('this.selectionlist: ')
			console.log(this.selectionlist)
			//getDaifalistByGroup

			let  fdata= {
				action:'insertlist',
				qyid:this.qyid,
				insertid:this.groupform.title,
				list: this.selectionlist,
			}
			
			getDaifalistByGroup(fdata).then(res => {
				if(res.code==1){
					console.log(res);
					this.$message({
						type: "success",
						message: res.msg,
					});
				}else{
					console.log(res)
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
				this.handleClose();
			})
			
		},
		getUserList() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			let fdata = {
				qyid: user.id,
			};
			console.log('getUsersReport................')
			getUsersReport(fdata).then(res => {
				if(res.code==1){
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					this.tableData=res.data
					this.tableDataExcel=res.dataExcel
					console.log('getUsersReporttttttttttttttttttttt')
				}else{
					console.log('eeeeeeeeeeeeeeeeeeeeee')
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})
		},
		// 我的模板列表
		gettemplist(){
			
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
 
			let  fdata= {
					sjk: this.sjk,
					action:'list',
					// status:this.status,
					// moresearch:'status,',
					qyid:user.id
				}
				console.log('go taocan',fdata);
			tongyong(fdata).then(res => {
				if(res.code==1){
				  console.log(res);
				  this.tableData=res.data
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})
		},
		// 读取数据库结构
		getsjk(){
			console.log('go sjk');
	 
			let  fdata= {
					sjk: this.sjk,
				
				}
			sjk(fdata).then(res => {
				if(res.code==1){
				  console.log('sjk',res);
				  this.sjkData=res.data
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})
		},
		replyto(){
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
					 
			this.qyid= user.id
		   	let  fdata= {
		   			do: 'sendwhatsapp',
		   		    qyid:this.qyid ,
		   			pageid:this.pageid,
					msg:this.form.msg ,
					Phone:this.hfdata.whatsapp,
					templateid:this.form.templateid
		
		   		}
				   console.log("fdata");
				console.log(fdata);
		this.$confirm('確定要發送嗎？').then(_ => {	 
		   	funk(fdata).then(res => {
		   		if(res.code>0){
		   		  console.log(res);
		   	      //this.gettemplist()
				  this.$message({
				      type: 'success',
				      message: 'ok'
				  })
				  this.dialogVisible = false;
		   		}else{
		   			this.$message({
		   				type: 'error',
		   				message: 'error'
		   			})
		   		}    
		   	})
			}).catch(_ => {
			
			　 
			
			})
		},
		
		
		replytoall(){
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
					 
			this.qyid= user.id
		   	let  fdata= {
		   			do: 'api_sendrw_insert',
		   		    qyid:this.qyid ,
		   			pageid:this.pageid,
					msg1:this.form.msg ,
					language:'zh_HK' ,
					type:'businessApi' ,
					daifaid:'9999' ,
					title:'PC群发' ,
				 
					templateid:this.form.templateid
		
		   		}
		this.$confirm('您確定要發送吗？').then(_ => {	 
		   	funk(fdata).then(res => {
		   		if(res.code>0){
		   		  console.log(res);
		   	      this.gettemplist()
				  this.$message({
				      type: 'success',
				      message: 'ok'
				  })
				  this.dialogVisible_duo = false;
		   		}else{
		   			this.$message({
		   				type: 'error',
		   				message: 'error'
		   			})
		   		}    
		   	})
			}).catch(_ => {
			
			　 
			
			})
		},
		// 修改key
		surekey() {
			 var user = JSON.parse(window.localStorage.getItem('userinfo'))
			 console.log(user);
		 
			 
			 this.formkey.sjk   = 'messenger_kehulist'
			 this.formkey.updatekey   = 'level,memo'
			 this.formkey.setkey   ='id' 
			 
			 
		 
			  let data = JSON.stringify(this.formkey);
			 
			  this.sform.parmas= data
			 
		    api_tongyong_edit(this.sform).then(res => {
				console.log(res);
		        if(res.code==1){
		            this.$message({
		                type: 'success',
		                message: res.msg
		            })
		            this.dialogVisible_key = false
				 
		        }else{
		            this.$message({
		                type: 'error',
		                message: res.msg
		            })
		        }    
		    })
		},
		sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop,order));
    },
    compare (propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    },
	sortChange_order({ prop, order }) {
      this.tableData_order.sort(this.compare(prop,order));
    }
		
    },
	
	

}
</script>
<style lang="scss" scoped>
	.el-pagination__total {
		display: inline-block;
		font-size: 13px;
		min-width: 35.5px;
		height: 28px;
		line-height: 28px;
		vertical-align: top;
		box-sizing: border-box;
	}
    .pagination{
        width: 100%;
        margin: 30px auto;
    }
    ::v-deep .el-select{
            width: 100%;
            
    }
  
</style>